export default {
    rowPerPage: 10,
    MaxLength:120,
    MaxLengthTitle:30,

  };